import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BeaconChatService {
  private beaconElement: HTMLElement | null = null;
  private renderer: Renderer2;

  // Possible Beacon Chat selectors
  private readonly beaconSelectors = [
    '.beacon-chat-button',
    '#beacon-container',
    '[data-beacon]',
    '.beacon-button',
    '#Beacon',
    '.Beacon-container',
    'iframe[src*="beacon"]'
  ];

  constructor(private rendererFactory: RendererFactory2) {
    // Create a renderer instance in the service since we don't have access to the component's renderer
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  /**
   * Hides the Beacon chat button
   * @returns Promise that resolves when the button is hidden or max attempts are reached
   */

  hideBeaconChat(): Promise<boolean> {
    return new Promise((resolve) => {
      // Try to find and hide the element immediately
      if (this.findAndToggleBeacon(false)) {
        resolve(true);
        return;
      }
    });
  }

  /**
   * Shows the Beacon chat button
   * @returns Promise that resolves when the button is shown or not found
   */
  showBeaconChat(): Promise<boolean> {
    return new Promise((resolve) => {
      // If we already have a reference to the element, show it
      if (this.beaconElement) {
        this.setElementVisibility(this.beaconElement, true);
        resolve(true);
        return;
      }
      // Otherwise try to find it one more time
      const found = this.findAndToggleBeacon(true);
      resolve(found);
    });
  }

  /**
   * Finds the Beacon chat element and toggles its visibility
   * @param show Whether to show or hide the element
   * @returns Whether the element was found
   */
  private findAndToggleBeacon(show: boolean): boolean {
    for (const selector of this.beaconSelectors) {
      const element = document.querySelector(selector) as HTMLElement;
      if (element) {
        if (!show) {
          this.beaconElement = element;
          this.setElementVisibility(element, false);
        } else {
          this.setElementVisibility(element, true);
        }
        return true;
      }
    }
    return false;
  }

  /**
   * Sets the visibility of an element
   * @param element The element to set visibility for
   * @param visible Whether the element should be visible
   */
  private setElementVisibility(element: HTMLElement, visible: boolean): void {
    if (visible) {
      this.renderer.setStyle(element, 'display', '');
      this.renderer.setStyle(element, 'visibility', '');
      this.renderer.setStyle(element, 'opacity', '');
    } else {
      this.renderer.setStyle(element, 'display', 'none');
      this.renderer.setStyle(element, 'visibility', 'hidden');
      this.renderer.setStyle(element, 'opacity', '0');
    }
  }
}
